/**
 * Builds the pre-filled drill-down question that appears in the chat
 * input when the user clicks a point on a bar/line chart. The template
 * is explicit about drill intent ("Me mostre a composição") so the
 * agent interprets it as decomposition, not as a request for more
 * precision on the same value. Format is pt-BR currency via Intl.
 */
export interface DrillDownContext {
  chartTitle: string;
  /**
   * Label of the clicked dataset (e.g., "Faturamento").
   * Reserved for multi-series charts — currently the chartTitle alone
   * is descriptive enough for the single-series case so the template
   * does not interpolate this value. Tasks 2 and 3 of the BIA interativo
   * plan still extract and pass this field so the future enhancement
   * does not require breaking the interface.
   */
  seriesLabel: string;
  pointLabel: string;
  value: number;
}

export function buildDrillDownQuestion(ctx: DrillDownContext): string {
  const formattedValue = formatBRL(ctx.value);
  return (
    `No gráfico "${ctx.chartTitle}", o ponto "${ctx.pointLabel}" ` +
    `tem ${formattedValue}. Me mostre a composição desse valor ` +
    `(por exemplo: por produto, por região, ou por cliente).`
  );
}

function formatBRL(n: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(n);
}
